import React from "react"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbRte from "../ui-kit/dfb_rte"
import DfbIcon from "../ui-kit/dfb_icon"
import DfbImage from "../ui-kit/dfb_image"
import CMediaVideo from "../elements/c_media_video"
import Section from "./section"

const MMultiColumnTeasers = (props) => {
  const columnMedia = (column) => {
    if (column.icon) {
      return (
        <DfbIcon
          icon_type={column.icon}
          add_class="m-MultiColumnTeasers-icon"
        />
      )
    } else if (column.image.src) {
      return (
        <DfbImage
          image={column.image}
          cover={true}
          aspect_ratio={column.aspect_ratio || "4:3"}
          add_class="m-MultiColumnTeasers-image"
        />
      )
    } else if (column.video_embed_id) {
      return (
        <CMediaVideo
          video_embed_id={column.video_embed_id}
          className="m-MultiColumnTeasers-media"
        />
      )
    } else {
      return null
    }
  }
  return (
    <Section
      baseClass="m-MultiColumnTeasers"
      className={
        props.data.background_color !== "white" &&
        props.data.background_color !== "grey"
          ? "u-Theme-dark"
          : ""
      }
      defaultPadding="small"
      data={props.data}
    >
      <div className="m-MultiColumnTeasers-wrapper">
        <div className="m-MultiColumnTeasers-container">
          <div className="m-MultiColumnTeasers-head">
            {props.data.subheadline && (
              <div className="m-MultiColumnTeasers-topline">
                {props.data.subheadline}
              </div>
            )}
            {props.data.headline && (
              <DfbHeadline
                headline={props.data.headline}
                headline_level="h3"
                add_class="m-MultiColumnTeasers-headline"
              />
            )}
          </div>
          <div className="m-MultiColumnTeasers-body">
            <div className="m-MultiColumnTeasers-row">
              {props.data.column.map((column, index) => (
                <div className="m-MultiColumnTeasers-column" key={index}>
                  <div className="m-MultiColumnTeasers-inner">
                    {columnMedia(column)}
                    {column.title && (
                      <DfbHeadline
                        headline={column.title}
                        headline_level="h5"
                        add_class="m-MultiColumnTeasers-title"
                      />
                    )}
                    {column.text && (
                      <DfbRte
                        text={column.text}
                        add_class="m-MultiColumnTeasers-text"
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MMultiColumnTeasers
